/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Video from './Video';

import styles from '../../../styles/partials/background.scss';

const propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.oneOf(['video', 'image', 'color']),
    video: PropTypes.shape({
        url: PropTypes.string,
    }),
    image: PropTypes.shape({
        url: PropTypes.string,
    }),
    color: PropTypes.string,
    current: PropTypes.bool,
    onComplete: PropTypes.func,
};

const defaultProps = {
    width: null,
    height: null,
    type: 'color',
    video: null,
    image: null,
    color: null,
    current: false,
    onComplete: null,
};

const Background = ({
    type, image, video, color, width, height, current, onComplete,
}) => {
    const medias = {
        image: get(image, 'url', null),
        video: get(video, 'mp4_url', get(video, 'url', null)),
        color,
    };
    const media = get(medias, type, null);
    return (
        <div className={styles.container}>
            {type === 'image' && media !== null ? (
                <div
                    className={styles.image}
                    style={{
                        backgroundImage: `url("${media}")`,
                    }}
                />
            ) : null}
            {type === 'video' && media !== null ? (
                <div className={styles.video}>
                    <Video
                        src={media}
                        videoWidth={video.width || null}
                        videoHeight={video.height || null}
                        width={width}
                        height={height}
                        playing={current}
                        autoPlay={current}
                        nativeAutoPlay={current}
                        size="cover"
                        preload="auto"
                        onEnded={onComplete}
                        muted
                        playsInline
                        loop
                    />
                </div>
            ) : null}
            {type === 'color' && media !== null ? (
                <div
                    className={styles.color}
                    style={{
                        backgroundColor: media,
                    }}
                />
            ) : null}
        </div>
    );
};

Background.propTypes = propTypes;
Background.defaultProps = defaultProps;

export default Background;



// WEBPACK FOOTER //
// ./js/components/partials/Background.jsx